import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension, CustomFieldExtensionSchema } from '@backstage/plugin-scaffolder-react';
import {
  RelatedGroupPicker,
  RelatedGroupPickerSchema,
} from './RelatedGroupPicker';

export const RelatedGroupPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'RelatedGroupPicker',
    component: RelatedGroupPicker,
    schema: RelatedGroupPickerSchema as CustomFieldExtensionSchema,
  }),
);